module.exports = __webpack_public_path__ + "img/pending-policies-icon-4.96afc90f.svg";